import Service from "@/utils/api/service";
import Media from "@/components/share/media";
import _debounce from "lodash.debounce";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "CreateNotification",
  data() {
    return {
      isCreating: false,
      display: {
        schedule: false,
        media: false,
        imagePreview: false,
      },
      body: {
        imageUrl: "",
        title: "",
        description: "",
        pushAt: "",
        customerIds: "",
        customerGroupIds: "",
      },
      data: {
        media: "",
      },

      models: {
        time: "",
        date: "",
      },
      customToolbarSpecification: [
        ["bold", "italic", "underline"],
        [
          {
            list: "ordered",
          },
          {
            list: "bullet",
          },
        ],
        ["link"],
      ],
      customers: [],
      customerGroups: this.$master?.customerGroups || [],
      allCustomerGroups: this.$master?.customerGroups || [],
      loading: {
        isCreating: false,
        isSearching: false,
      },
    };
  },
  components: {
    Media,
    Multiselect,
  },
  computed: {
    ...mapState(["permissions"]),
    debouncedOnSearchCustomers() {
      return _debounce(this.searchCustomers, 500);
    },
    debouncedOnSearchCustomerGroups() {
      return _debounce(this.searchCustomerGroups, 500);
    },
    customerOptions() {
      return this.customers.map((c) => ({
        ...c,
        displayName: c.bpName
          ? c.bpName
          : !c.firstName && !c.lastName && c.bpName
          ? c.bpName
          : `${c.firstName || ""} ${c.lastName || ""}`.trim(),
      }));
    },
    customerGroupOptions() {
      return this.customerGroups.map((c) => ({
        ...c,
        displayName: `${c.name || ""}`.trim(),
      }));
    },
  },
  created() {
    setTimeout(() => {
      // this.searchCustomers();
      this.searchCustomerGroups();
    }, 500);
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "ListNotification",
      });
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    // customer group change
    onCustomerGroupSelect() {
      this.searchCustomers();
      // return selectedOption;
    },

    onCustomerGroupRemove(removedGroup) {
      this.onAutoRemoveCustomerByCustomerGroupId(removedGroup);

      if (this.body.customerGroupIds && !this.body.customerGroupIds.length) {
        this.body.customerIds = [];
      }
    },

    onAutoRemoveCustomerByCustomerGroupId(removedGroup) {
      if (this.body.customerIds && this.body.customerIds.length) {
        const updatedCustomerIds = this.body.customerIds.filter(
          (item) => item?.customerGroupId !== removedGroup?.id
        );

        this.body.customerIds = updatedCustomerIds;
      }

      this.searchCustomers();
    },

    // search
    async searchCustomers(query) {
      if (!this.checkoutPermission("LIST_CUSTOMER_ACCOUNT")) return;

      this.loading.isSearching = true;
      let search = { search: query };

      // Build initial query object — WITHOUT `page`
      let setQuery = {
        limit: 10,
        offset: 0,
        status: "active",
        customerGroupIds: this.body.customerGroupIds?.map((group) => group.id),
        ...search,
      };

      // Filter out empty/null/undefined values and empty arrays
      let cleanQuery = Object.entries(setQuery).reduce((acc, [key, value]) => {
        if (
          value !== null &&
          value !== undefined &&
          value !== "" &&
          (!Array.isArray(value) || value.length > 0)
        ) {
          acc[key] = value;
        }
        return acc;
      }, {});

      // Build query string manually
      let queryParts = [];

      // Handle array params like customerGroupIds
      Object.entries(cleanQuery).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((val) => {
            queryParts.push(
              `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
            );
          });
        } else {
          queryParts.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
          );
        }
      });

      let params = queryParts.join("&");

      await Service.getCustomers(`?${params}`).then((response) => {
        this.loading.isSearching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.searchCustomers();
              }
            });
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          this.customers = response?.data;
        }
      });
    },

    searchCustomerGroups(query) {
      if (!query || query.trim() === "") {
        this.customerGroups = [...this.allCustomerGroups];
        return;
      }

      this.filterCustomerGroup(this.allCustomerGroups, query);
    },

    filterCustomerGroup(data, search) {
      if (!search || search.trim() === "") {
        this.customerGroups = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.customerGroups = items;
    },

    removeMedia() {
      this.data.media = "";
      this.body.imageUrl = "";
    },
    closeModal() {
      this.display.media = false;
      this.display.imagePreview = false;
    },

    imagePreview() {
      if (this.data.media != "") {
        this.display.imagePreview = true;
      }
    },

    chooseImage() {
      this.display.media = true;
    },

    existedMediaCallback(media) {
      this.data.media = media;
      this.body.imageUrl = media.url;
      this.closeModal();
    },

    fileToPath(file) {
      return window.URL.createObjectURL(file);
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    getNameFromUrl(url) {
      return url.split("/").pop();
    },

    submitCreateNotification() {
      if (this.models.time || this.models.date) {
        let validatedMessage = this.validateScheduleBody(this.body);
        if (validatedMessage == "ok") {
          this.isCreating = true;
          this.createScheduleNotification();
        } else {
          this.$toasted.show(validatedMessage);
        }
      } else {
        let validatedMessage = this.validateBody(this.body);
        if (validatedMessage == "ok") {
          this.isCreating = true;
          this.createNotification();
        } else {
          this.$toasted.show(validatedMessage);
        }
      }
    },

    validateScheduleBody(data) {
      if (!data.title) {
        return "Title cannot be empty!";
      } else if (!this.models.date) {
        return "Date cannot be empty!";
      } else if (!data.description) {
        return "Description cannot be empty!";
      } else {
        return "ok";
      }
    },

    validateBody(data) {
      if (!data.title) {
        return "Title cannot be empty!";
      } else if (!data.description) {
        return "Description cannot be empty!";
      } else {
        return "ok";
      }
    },

    createScheduleNotification() {
      this.body.pushAt = this.models.date + ":00.000Z";
      const body = {
        ...this.body,
        customerIds: Array.isArray(this.body.customerIds)
          ? this.body.customerIds.map((item) => item.id)
          : [],
        customerGroupIds: Array.isArray(this.body.customerGroupIds)
          ? this.body.customerGroupIds.map((item) => item.id)
          : [],
      };

      // this.body = {
      //   imageUrl: "",
      //   title: "",
      //   description: "",
      //   pushAt: this.models.date ? this.models.date + ":00.000Z" : "",
      //   status: "",
      //   customerIds: Array.isArray(this.body.customerIds)
      //     ? this.body.customerIds.map((item) => item.id)
      //     : [],
      //   customerGroupIds: Array.isArray(this.body.customerGroupIds)
      //     ? this.body.customerGroupIds.map((item) => item.id)
      //     : [],
      // };

      Service.createScheduleNotification(body).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.createScheduleNotification();
              }
            });
          } else {
            this.isCreating = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isCreating = false;
          this.resetBody();
          this.$toasted.show("Notification has been created.");
        }
      });
    },

    createNotification() {
      delete this.body.pushAt;
      const body = {
        ...this.body,
        customerIds: Array.isArray(this.body.customerIds)
          ? this.body.customerIds.map((item) => item.id)
          : [],
        customerGroupIds: Array.isArray(this.body.customerGroupIds)
          ? this.body.customerGroupIds.map((item) => item.id)
          : [],
      };

      Service.createNotification(body).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.createNotification();
              }
            });
          } else {
            this.isCreating = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isCreating = false;
          this.resetBody();
          this.$toasted.show("Notification has been created.");
        }
      });
    },

    resetBody() {
      this.body = {
        imageUrl: "",
        title: "",
        description: "",
        date: "",
        status: "",
        customerIds: [],
        customerGroupIds: [],
      };
      this.data.media = "";
      this.models.time = "";
      this.models.date = "";
      this.goBack();
    },
  },
};
